import { distortionClass, distortionBar } from './index';

const valuableMainVisual = (() => {
  const pageValuable = (document.getElementById("pageValuable") != null);
  if (pageValuable) {


    let sW = window.innerWidth;
    let sH = window.innerHeight;


    const jsSecMain = document.getElementById('jsSecMain');
    const jsMainImgBox = document.getElementById('jsMainImgBox');
    jsSecMain.style.height = `${sH}px`
    jsMainImgBox.style.height = `${sH}px`


    let images
    let AspectRatioX
    let AspectRatioY

    if (sW > 750) {
      images = [
        '../assets/build/img/valuable/main_1.jpg',
        '../assets/build/img/valuable/main_2.jpg',
      ]
      AspectRatioX = 2880
      AspectRatioY = 1800
    } else {
      images = [
        '../assets/build/img/valuable/main_1_sp.jpg',
        '../assets/build/img/valuable/main_2_sp.jpg',
      ]
      AspectRatioX = 1440
      AspectRatioY = 1880
    }

    let slide = new distortionClass({
      el: '#jsMainImg',
      inner: '#jsMainImgInner',
      images: images,
      AspectRatioX: AspectRatioX,
      AspectRatioY: AspectRatioY,
      displacement: '../assets/lib/distortion/displacement/disp3.jpg',
      speed: 2.5,
    });


    window.addEventListener('load', () => {

      setTimeout(() => {
        gsap.to('#jsMainTxt path', {
          opacity: 1,
          duration: 2,
          stagger: {
            amount: 3,
            from: 'random',
          },
          onStart: () => {
            startFunc()
          },
        });
      }, 0)

      const startFunc = () => {
        gsap.to('#jsMainImgBox', {
          opacity: 1,
          duration: .8,
          filter: "blur(0px)",
          onComplete: () => {
            setInterval(slide.nextSlide, 5000, { passive: true });
            distortionBar(0)
            scrollIntro()
            // scrollHide()
          },
        });
      }

    });

    gsap.set('#jsSecMain .js-cover', {
      opacity: 0,
    });
    const scrollIntro = () => {
      gsap.to('#jsSecMain .js-cover', {
        opacity: 1,
        scrollTrigger: {
          trigger: '#jsSecIntro',
          start: 'top center',
          end: 'top center',
          toggleActions: "play none reverse none",
          // markers: true,
        }
      });
    }

    // const scrollHide = () => {
    //   gsap.to('#jsSecMain', {
    //     opacity: 0,
    //     duration: 1,
    //     scrollTrigger: {
    //       trigger: '#jsMainEndPoint',
    //       start: 'center center',
    //       end: 'center center',
    //       toggleActions: "play none reverse none",
    //       // markers: true,
    //     }
    //   });
    // }


  }
})();
export default valuableMainVisual;